import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import { initPostHog } from './lib/posthog.js';
import { initSentry } from './lib/sentry.js';
import './index.css';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

if (typeof window !== 'undefined') {
  const initDeferredServices = () => {
    initPostHog();
    initSentry();
  };

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(initDeferredServices, { timeout: 2000 });
  } else {
    setTimeout(initDeferredServices, 300);
  }

  // Register PWA service worker
  if ('serviceWorker' in navigator) {
    const registerSW = () => {
      navigator.serviceWorker
        .register('/sw.js')
        .then((reg) => {
          if (import.meta.env.DEV) {
            console.log('[PWA] Service Worker registered:', reg.scope);
          }
        })
        .catch((err) => {
          console.warn('[PWA] Service Worker registration failed:', err);
        });
    };

    if (document.readyState === 'complete') {
      registerSW();
    } else {
      window.addEventListener('load', registerSW);
    }
  }
}
